import { IoMdInformationCircleOutline } from "react-icons/io";
import { useSelector } from "react-redux";
import OTPInput from "react-otp-input";
import { useCallback, useState } from "react";
import { Formik } from "formik";
import axios from "../../axios";
import { AnimatePresence, motion } from "framer-motion";
import { CircleCheckBig } from "lucide-react";
import { notifyDanger, notifySuccess, RazorPayBtn } from "../../action/customFn";
import { useNavigate } from "react-router-dom";
import PaymentVerificationLoader from "../PaymentVerificationLoader";
import { FaArrowLeft } from "react-icons/fa6";

export default function ATSModal({ purchasePlan, setShowAtsModal }) {

  const navigate = useNavigate();
  const countryData = useSelector((state) => state.jobData.countryData);
  const userIpInfo = useSelector((state) => state.paymentData.userIpInfo);
  const allCurrency = useSelector((state) => state.paymentData.allCurrency);
  const [showEmailModal, setShowEmailModal] = useState(false);
  const [selectedPlan, setSelectedPlan] = useState(null);
  const [otp, setOtp] = useState("");
  const [otpTimer, setOTPTimer] = useState(null);
  const [otpHasExpired, setOtpHasExpired] = useState(false);
  const [amount, setAmount] = useState(0);
  const [otpSentFlag, setOtpSentFlag] = useState(false);
  const [waitSendingOTP, setWaitSendingOTP] = useState(false);
  const [verificationSuccess, setVerificationSuccess] = useState(false);
  const [emailAlreadyResigtered, setEmailAlreadyRegistered] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [waitForPaymentVerification, setWaitForPaymentVerification] = useState(false);
  const [waitForAccountCreation, setWaitForAccountCreation] = useState(false);
  const [customerEmail, setCustomerEmail] = useState("")

  async function sendOTP(email) {
    try {
      if (!email) return;
      setWaitSendingOTP(true)
      const url = "/ats/send-ats-email-otp";
      const data = {
        email: email,
        purchasePlan
      }
      const res = await axios.post(url, data);
      if (res.status === 200 && res.data.success === true) {
        setOtpSentFlag(true);
        setTimeout(() => {
          setOtpSentFlag(false);
        }, 3000)
      }
    } catch (error) {
      console.log(error);
      if (error.response.status === 400) {
        setEmailAlreadyRegistered(true);
      }
    } finally {
      setWaitSendingOTP(false);
    }
  }


  const starterPlanFunction = async () => {
    try {
      const url = "/ats/starter-user-ac";
      const data = { email: customerEmail, };

      const response = await axios.post(url, data);

      if (response.status === 200 && response.data.success) {
        notifySuccess("Starter user registered!")
        navigate("/ats");
      }

    } catch (error) {
      console.log(error);
    }
  }

  const loadScript = useCallback(function loadScript(src) {
    return new Promise((resolve) => {
      const script = document.createElement("script");
      script.src = src;
      script.onload = () => {
        resolve(true);
      };
      script.onerror = () => {
        resolve(false);
      };
      document.body.appendChild(script);
    });
  }, []);

  const rzpFunction = async () => {
    if (1) {
      const scp_r = await loadScript(
        "https://checkout.razorpay.com/v1/checkout.js"
      );
      if (!scp_r) {
        window.alert("Razorpay Script Failed to load");
        return;
      }
      let customNote = {
        product_type: "ats-metb",
      };
      RazorPayBtn(
        false,
        setIsLoading,
        { ...purchasePlan, amount: purchasePlan.billingCycle === "monthly" ? purchasePlan.monthlyPrice : purchasePlan.yearlyPrice, currency: "USD", country: userIpInfo.country_name, product_type: "ats-metb", email: customerEmail, },
        null,
        afterPayment,
        null,
        customNote
      );
    }
  };

  async function afterPayment(data, dataMain, response) {
    try {
      console.log("After Payment was called", data, dataMain, response);
      if (response.razorpay_payment_id) {
        setWaitForPaymentVerification(true);
        setWaitForAccountCreation(true);
        // verify payment id from the backend 
        const verificationResponse = await axios.post("/payment/verify", {
          orderId: data.order_id,
          response: response,
          atsData: dataMain,
        });

        if (verificationResponse.status === 200) {
          setWaitForPaymentVerification(false);
          setWaitForAccountCreation(false);
          localStorage.setItem("atsuser", JSON.stringify(dataMain))
          setTimeout(() => {
            navigate("/ats");
          }, 2000)
        }
      }
    } catch (error) {
      console.log(error);
      notifyDanger("Some error occurred");
    }
  }

  return (
    <>
      {(waitForPaymentVerification || waitForAccountCreation) ? <PaymentVerificationLoader sendingOfferLetter={false} verificationSuccess={!waitForPaymentVerification && !waitForAccountCreation} />
        :
        <div className="ats-plans-modal">
          <div className="ats-plans-content">
            <>
              <div className="ats-plans-box-inner">
                <Formik
                  initialValues={{ email: '', otp: '' }}
                  validate={values => {
                    const errors = {};
                    if (!values.email) {
                      errors.email = 'Required';
                    } else if (
                      !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i.test(values.email)
                    ) {
                      errors.email = 'Invalid email address';
                    }
                    if (!values.otp) {
                      errors.otp = "OTP is required";
                    }
                    return errors;
                  }}
                  onSubmit={async (values, { setSubmitting, setErrors, }) => {
                    try {
                      setSubmitting(true);
                      const url = "/ats/verify-otp";
                      const response = await axios.post(url, values);
                      if (response.status === 200 && response.data.success === true) {
                        setVerificationSuccess(true);
                      }
                    } catch (error) {
                      if (error.response.status === 400) {
                        setErrors({ otp: "Invalid OTP Entered" })
                      }
                      console.log(error);
                    } finally {
                      setSubmitting(false);
                    }
                  }}
                >
                  {({
                    values,
                    errors,
                    touched,
                    handleChange,
                    handleBlur,
                    handleSubmit,
                    isSubmitting,
                    setFieldValue,
                  }) => (
                    <form onSubmit={handleSubmit}>
                      <p
                        onClick={() => {
                          setShowAtsModal(false);
                        }}
                        className=""
                        style={{color:"#232323", display:"flex", alignItems:'center', gap:"4px", cursor:"pointer"}}
                      >
                        <FaArrowLeft  />
                        Back
                      </p>
                      <AnimatePresence>
                        {otpSentFlag && <motion.div
                          initial={{ height: 0, y: 10, opacity: 0 }}
                          animate={{ height: "auto", y: 0, opacity: 1 }}
                          exit={{ height: 0, y: 10, opacity: 0 }}
                          style={{ padding: "5px 12px", background: "oklch(72.3% 0.219 149.579)", color: "#fff", fontWeight: "500", borderRadius: "5px" }}
                        >
                          OTP has been sent to the provided email!
                        </motion.div>}
                      </AnimatePresence>
                      <AnimatePresence>
                        {emailAlreadyResigtered && <motion.div
                          initial={{ y: 10, opacity: 0 }}
                          animate={{ y: 0, opacity: 1 }}
                          exit={{ y: 10, opacity: 0 }}
                          style={{ padding: "5px 12px", background: "oklch(98.7% 0.022 95.277)", color: "oklch(55.5% 0.163 48.998)", fontWeight: "500", borderRadius: "5px" }}
                        >
                          Email is already registered. Log In here
                        </motion.div>}
                      </AnimatePresence>
                      <label htmlFor="atsplans-reg-input">Email</label>
                      <div style={{ display: "flex", alignItems: "stretch", gap: "5px" }}>
                        <input name="email" onChange={(e) => { setEmailAlreadyRegistered(false); setFieldValue("email", e.target.value); setCustomerEmail(e.target.value) }} onBlur={handleBlur} value={values.email} id="atsplans-reg-input" type="email" disabled={verificationSuccess} />
                        <button className="send-otp-btn" onClick={() => { sendOTP(values.email) }} style={{ flex: "1", borderRadius: "8px", border: "1px dashed oklch(51.1% 0.096 186.391)", fontWeight: "600", outline: "none" }} disabled={waitSendingOTP || verificationSuccess} type="button">{waitSendingOTP ? 'Sending...' : 'Send OTP'}</button>
                      </div>
                      <span>Please enter correct email, your ATS reports will be sent to this email</span>
                      <div style={{ paddingBlock: "10px" }}></div>
                      <label htmlFor="">Verify OTP</label>
                      <AnimatePresence>
                        {touched.otp && errors.otp && <motion.div
                          initial={{ y: 10, opacity: 0 }}
                          animate={{ y: 0, opacity: 1 }}
                          exit={{ y: 10, opacity: 0 }}
                          style={{ padding: "5px 12px", background: "oklch(93.6% 0.032 17.717)", color: "oklch(63.7% 0.237 25.331)", fontWeight: "500", borderRadius: "5px" }}
                        >
                          {errors.otp}
                        </motion.div>}
                      </AnimatePresence>
                      <div style={{ display: "flex", alignItems: "stretch", gap: "5px", justifyContent: "center" }}>
                        <OTPInput
                          containerStyle={{ display: "flex", justifyContent: "center" }}
                          inputStyle={{
                            padding: "3px",
                            width: "50px",
                            height: "50px",
                            background: "#fff",
                            border: "1px solid rgba(0,0,0,0.2)",
                            outline: "none",
                          }}
                          
                          value={values.otp}
                          onChange={(val) => { setFieldValue("otp", val) }}
                          numInputs={5}
                          renderSeparator={
                            <span style={{ display: "inline-block", margin: "0px 10px" }}>
                              °
                            </span>
                          }
                          renderInput={(props) => <input disabled={verificationSuccess} {...props} />}
                        />
                      </div>
                      {verificationSuccess ? <div style={{ border: "1px solid #aaa", display: "flex", flexDirection: 'column', alignItems: 'center', paddingBlock: "12px", background: "#fff", marginTop: "20px" }}>
                        <CircleCheckBig color="green" size={32} />
                        <p style={{ color: "#000", marginBlockEnd: "0px", marginTop: "5px" }}>Email Verified!</p>
                      </div> : <button style={{ flex: "1", borderRadius: "8px", border: "none", color: "#fff", fontWeight: "600", padding: "8px 12px", width: "75%", margin: "20px auto", marginTop: "20px", background: "rgb(36, 36, 36)" }} disabled={isSubmitting} type="submit">{isSubmitting ? 'Please Wait' : 'Verify Email'}</button>}
                    </form>
                  )}
                </Formik>
              </div>
              <div
                className="ats-content-bill-right"
              >
                <div style={{ display: "flex", alignItems: "stretch", gap: "15px" }}>
                  <figure
                    style={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      padding: "5px",
                      width: "60px",
                      height: "60px",
                      borderRadius: "8px",
                      background:
                        "linear-gradient(to bottom right,rgb(86, 227, 242), #0069a8, #000)",
                    }}
                  >
                    <img src="/icons8-resume-64.png" />
                  </figure>
                  <div>
                    <h4
                      style={{
                        fontFamily: "DM Sans",
                        color: "#000",
                        fontWeight: "700",
                        marginBottom: "0px",
                      }}
                    >
                      ATS Resume Analyzer
                    </h4>
                    <p
                      style={{
                        color: "gray",
                        fontWeight: "500",
                        fontSize: "15px",
                        marginBottom: "0px",
                      }}
                    >
                      Dated {new Date().toLocaleDateString()}
                    </p>
                  </div>
                </div>
                <div
                  style={{
                    background: "#FAFAFA",
                    borderRadius: "10px",
                    paddingBlock: "10px",
                  }}
                >
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      paddingInline: "10px",
                      borderBottom: "1px solid #eee",
                      marginBottom: "5px",
                      paddingBlock: "5px",
                    }}
                  >
                    <span>1x {purchasePlan.name} Plan ATS ({purchasePlan.billingCycle})</span>
                    <span>
                      {"USD"} {purchasePlan.billingCycle === "monthly" ? purchasePlan.monthlyPrice : purchasePlan.yearlyPrice}
                    </span>
                  </div>
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      paddingInline: "10px",
                      borderBottom: "1px solid #eee",
                      marginBottom: "5px",
                      paddingBlock: "5px",
                    }}
                  >
                    <span>Subtotal</span>
                    <span>
                      {"USD"} {purchasePlan.billingCycle === "monthly" ? purchasePlan.monthlyPrice : purchasePlan.yearlyPrice}
                    </span>
                  </div>
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      paddingInline: "10px",
                      borderBottom: "1px solid #eee",
                      marginBottom: "5px",
                      paddingBlock: "5px",
                    }}
                  >
                    <span>Tax</span>
                    <span>
                      {"USD"} {"0"}
                    </span>
                  </div>
                  {true && (
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                        paddingInline: "10px",
                        borderBottom: "1px solid #eee",
                        marginBottom: "5px",
                        paddingBlock: "8px",
                        background: "rgba(183, 255, 104, 0.46)",
                      }}
                    >
                      <span>Applicable Discount</span>
                      <span>
                        - {"USD"} {"0"}
                      </span>
                    </div>
                  )}
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      paddingInline: "10px",
                      borderBottom: "1px solid #eee",
                      marginBottom: "5px",
                      paddingBlock: "5px",
                      marginTop: "15px",
                    }}
                  >
                    <strong>Total Billing Amount</strong>
                    <strong>
                      {"USD"} {purchasePlan.billingCycle === "monthly" ? purchasePlan.monthlyPrice : purchasePlan.yearlyPrice}
                    </strong>
                  </div>
                  <p
                    style={{
                      marginTop: "20px",
                      marginBottom: "0px",
                      paddingInline: "10px",
                    }}
                  >
                    Invoice, ATS credentials and reports will be sent to your registered email <IoMdInformationCircleOutline size={16} />
                  </p>
                  <button
                    disabled={!verificationSuccess}
                    onClick={purchasePlan.name === "Starter" ? starterPlanFunction : rzpFunction}
                    style={{
                      background: verificationSuccess ? "#242424" : "#909090",
                      color: "#fff",
                      border: "none",
                      outline: "none",
                      padding: "8px 20px",
                      borderRadius: "8px",
                      fontWeight: "600",
                      marginLeft: "12px",
                      width: "100%",
                      marginTop: "20px",
                      cursor: verificationSuccess ? "pointer" : "not-allowed"
                    }}
                  >
                    {purchasePlan.name === "Starter" ? "Create Free Account" : "Proceed to Payment"}
                  </button>
                </div>
              </div>
            </>
          </div>
        </div>
      }
    </>
  )
}